import {
   GET_TESTS,
   GET_NEXT_TESTS,
   SAVE_COC_TYPES,
   ADD_COC_TYPE,
   UPDATE_COC_TYPE,
   DELETE_COC_TYPE,
   ADD_NEW_TEST,
   REMOVE_TEST,
   UPDATE_ANALYSIS_TYPE_NAME
}  from './../actions/types';

const INITIAL_STATE = {
  tests: [],
  cocTypes: [],
};

export default function (state = INITIAL_STATE , action)
{
    switch(action.type){
        case GET_TESTS : 
        return {
            ...state,
            tests: action.payload,
        }

        case SAVE_COC_TYPES:
        return {
            ...state,
            cocTypes: action.payload
        }

        case ADD_COC_TYPE:
        return {
            ...state,
            cocTypes: [...state.cocTypes, action.payload]
        }

        case UPDATE_COC_TYPE: {
            const { cocTypeId, newName, index } = action.payload;
            return {
                ...state,
                cocTypes: state.cocTypes.map((ct, i) =>
                    i === index ? { ...ct, name: newName } : ct
                )
            }
        }

        case DELETE_COC_TYPE: {
            const { index } = action.payload;
            return {
                ...state,
                cocTypes: [...state.cocTypes.slice(0, index), ...state.cocTypes.slice(index + 1)]
            }
        }

        case ADD_NEW_TEST: 
        return {
            ...state,
            tests: [...state.tests, action.payload]
        }

        case REMOVE_TEST: {
            const {index} = action;
            return {
                ...state,
                tests: [...state.tests.slice(0, index), ...state.tests.slice(index + 1)]
            }
        }

        case UPDATE_ANALYSIS_TYPE_NAME: {
             const {index, updateName} = action;
         return {
             ...state,
             tests: [...state.tests.slice(0, index), {...state.tests[index], analysis_type: updateName}, ...state.tests.slice(index + 1)]
         }
        }

        case GET_NEXT_TESTS : 
        return {
            ...state,
            tests: action.payload,
        }
    
     
        default :
        return {
            ...state
        };
    }
}